/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-01T17:22:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-03-28T15:58:04-07:00
*/


import React, { Component } from 'react';
import glamorous, { Div } from 'glamorous';
import Container from '../../blocks/Container';
import userLockup from './UserLockup';
import {whoPays} from "../../../mt";
import MediaQuery from 'react-responsive';

//style stuff
import {dimensions, box, spacing, type, textColor, borders, leading } from '../../../style';

/**
 * Backdrop comoponent for the trip.
 * Holds either an image or a map of the trip destination.
 */

const TripBackdrop = glamorous.div(
  {
    backgroundSize: 'cover',
    minHeight: 200,
    backgroundPosition: 'center'
  },
  ({src}) => (
    {backgroundImage: `url(${src})`}
  )
)

const TripHeaderContainer = glamorous.div(
  {
    position: 'relative',

    [dimensions.SCREEN_MIN_MD]: {
      width: '95%',
      marginRight: 'auto'
    }
  },
  ({hasPhoto}) => {
    if (!hasPhoto) return {
      [dimensions.SCREEN_MAX_MD]: {
        ':after' : {
          content: '""',
          padding: '1px 1px 1px 0',
          height: 21,
          width: 116,
          textAlign: 'right',
          display: 'block',
          backgroundImage: 'url(https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white.png)',
          backgroundPosition: 'right',
          backgroundRepeat: 'no-repeat',
          position: 'absolute',
          top: 4,
          right: 4,
        }
      }
    }
  }
)

const TripBackdropContainer = glamorous.div(
  {
    position: 'relative',
    paddingTop: 220,

    [dimensions.SCREEN_MIN_MD]: {
      paddingTop: '120%'
    }
  }
)

const TitleOverlay = glamorous.div(
  {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    background: 'linear-gradient(to bottom, rgba(18,40,57,1), rgba(18,40,57,0))',
    padding: 18,

    [dimensions.SCREEN_MAX_MD]: {
      bottom: 0,
      top: 'auto',
      paddingBottom: 22,
      background: 'linear-gradient(to top, rgba(18,40,57,1), rgba(18,40,57,0))',
    }
  }
)
const TripTitle = glamorous.div(
  {
    fontSize: 28,
    color: "#fff",

  }
)

class TripDetailsHeader extends Component {
  render() {
    const {
      city,
      country,
      region,
      username,
      avatar,
      age,
      isMe,
      backdropPhoto,
      hasPhoto
    } = this.props;

    let UserLockup = userLockup()
    
    return (
        <TripHeaderContainer>
          <TripBackdrop 
            src={backdropPhoto}
            hasPhoto={hasPhoto}
          >
            <TripBackdropContainer hasPhoto={hasPhoto}>
              <TitleOverlay>
                {!isMe &&
                  <MediaQuery maxWidth={783}>
                    <Div 
                      marginBottom={4}
                    >
                      <UserLockup 
                        color="#fff"
                        username={username}
                        city={city}
                        country={country}
                        region={region}
                        age={age}
                        avatar={avatar}
                      />
                    </Div>
                  </MediaQuery>
                }
                <Div
                  fontSize={14}
                  color="#9E9E9E"
                >
                  Traveling to
                </Div>
                <TripTitle>{`${city ? city + ', ' : ''}${region ? region + ', ': ''}${country ? country : ''}`}</TripTitle>
              </TitleOverlay>
            </TripBackdropContainer>
          </TripBackdrop>
        </TripHeaderContainer>
    );
  }
}


export default TripDetailsHeader;


// WEBPACK FOOTER //
// ./src/components/pages/Trips/TripDetailsHeader.jsx